import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, AlertCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PreviewPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [status, setStatus] = useState("Initializing preview mode...");

  useEffect(() => {
    const token = searchParams.get("token");
    
    if (!token) {
      setError("No preview token provided");
      return;
    }

    // Store the token for authentication
    localStorage.setItem("token", token);
    setStatus("Preview mode activated! Redirecting...");
    
    // Force a complete page reload to ensure React re-renders with the token
    // We use replace to avoid back-button issues
    setTimeout(() => {
      window.location.replace("/library");
    }, 300);
  }, [searchParams]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center max-w-md mx-auto p-6">
          <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <p className="text-red-500 mb-4 text-lg">{error}</p>
          <Button onClick={() => window.location.href = "/admin"} variant="outline">
            Return to Admin Panel
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-gold mx-auto mb-4" />
        <p className="text-muted-foreground">{status}</p>
        <p className="text-xs text-muted-foreground mt-2">Preview mode active</p>
      </div>
    </div>
  );
}
